export default function InvoicesPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Invoices</h1>
      <p className="text-slate-500">Invoices list placeholder</p>
    </div>
  );
}
